export default "__VITE_ASSET__CujiFRCT__"